import React from 'react'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import AutoHeightTextarea from '../../CommonComponent/AutoHeightTextarea'
import { PrivateAxiosFile } from '../../../environment/AxiosInstance';
import { ErrorMessage, SuccessMessage, WaringMessage } from '../../../environment/ToastMessage';
import moment from 'moment';
import { UserAuth } from '../../auth/Auth';
import { splitText } from '../../../environment/Helper';

function TaskDoneModal({ onTaskComplete, taskDoneShow, taskDoneModalClose, Tab, GetInprogress, GetTodo, setTableData, tableData, setAllTableData, allTableData, taskDoneValue, handleMessageShow, setTaskCloseInputValue, taskCloseInputValue }) {
    const { User, Logout } = UserAuth();
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        let fileSize = file?.size;
        if (Number(fileSize) >= 20 * 1024 * 1024) {
            WaringMessage("This image in getter than 20MB")
        } else {
            setTaskCloseInputValue({ ...taskCloseInputValue, file: e.target.files[0] });
        }
    };
    const SubmitTaskDOne = (e) => {
        e.preventDefault();
        // setLoading(true);
        let formData = new FormData();
        formData.append('remark', taskCloseInputValue.remark)
        formData.append('done_file_link', taskCloseInputValue.done_file_link)
        formData.append('file', taskCloseInputValue.file)
        formData.append('id', taskCloseInputValue.id)
        PrivateAxiosFile.post("task/task-done", formData)
            .then((res) => {
                SuccessMessage(res.data.message);
                // setLoading(false)
                // const PresentAllData = allTableData.filter((item) => item.id == taskCloseInputValue.id ? item.delegation_status_id = 3 : item)
                // const presentTableData = tableData.filter((item) => item.id == taskCloseInputValue.id ? item.delegation_status_id = 3 : item)
                // setTableData(presentTableData)
                // setAllTableData(PresentAllData)
                if (Tab == "inprogress") {
                    GetInprogress();
                }
                if (Tab == "todo") {

                    GetTodo();
                }

                // setLoading(false);
                taskDoneModalClose();
                if (onTaskComplete) {
                    onTaskComplete();
                }
            }).catch((err) => {
                // setLoading(false);
                // if (err.response.status == 401) {
                //     Logout();
                // }
                ErrorMessage(err.response.data.error)
            })
    }
    return (
        <Modal id="taskTaskDone"
            show={taskDoneShow}
            onHide={taskDoneModalClose}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header closeButton className="gth-blue-light-bg">
                <Modal.Title className="gth-modal-title">Complete Task of <span>{taskDoneValue && splitText(taskDoneValue.name, 27)}</span></Modal.Title>
            </Modal.Header>
            <form onSubmit={SubmitTaskDOne} action=''>
                <Modal.Body className='pb-1'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Assigned By : </label>
                                <p className='mb-0'>{taskDoneValue && taskDoneValue.assigned_by && User.find(data => data.id == taskDoneValue.assigned_by)?.name}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Planned Date : </label>
                                <p className='mb-0'>{taskDoneValue && taskDoneValue.planned_date && moment(taskDoneValue.planned_date).format("DD-MM-YYYY")}</p>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className="form-group">
                                <label className="form-label">Remarks : </label>
                                <textarea className="form-control" name="remarks" rows="3" onChange={(e) => setTaskCloseInputValue({ ...taskCloseInputValue, remark: e.target.value })}>{taskCloseInputValue.remark}</textarea>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className="form-group">
                                <label className="form-label">File : {taskDoneValue && taskDoneValue.file_is_require ? <span className='text-red'>*</span> : ''}</label>
                                <div className="custom-file-input">
                                    <input
                                        type="file"
                                        name='file'
                                        className='form-control'
                                        accept=".png, .jpg, .jpeg, .pdf, .xls, .xlsx , .doc"
                                        onChange={handleFileChange}
                                        required={taskDoneValue && taskDoneValue.file_is_require ? true : false}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='form-group'>
                                <label className='form-label'>Attach file link</label>
                                {/* <textarea className='form-control' name='attachment_file_link' placeholder='Attach Link' cols={14} onChange={(e) => setTaskCloseInputValue({ ...taskCloseInputValue, done_file_link: e.target.value })} /> */}
                                <AutoHeightTextarea placeholder="Attach file link"
                                    value={taskCloseInputValue.done_file_link}
                                    onChange={(e) =>
                                        setTaskCloseInputValue({
                                            ...taskCloseInputValue,
                                            done_file_link: e.target.value
                                        })
                                    } />
                                <p className='mb-0 mt-1 f-s-12'>
                                    <div className='d-flex gap-2 mb-1'>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width={20}
                                            height={20}
                                            x={0}
                                            y={0}
                                            viewBox="0 0 511.999 511.999"
                                            xmlSpace="preserve"
                                            className=""
                                        >
                                            <g>
                                                <path
                                                    fill="#0066dd"
                                                    d="m38.563 418.862 22.51 39.042c4.677 8.219 11.41 14.682 19.319 19.388l80.744-57.248.147-82.19-80.577-36.303L0 337.565c-.016 9.09 2.313 18.185 6.991 26.404z"
                                                    opacity={1}
                                                    data-original="#0066dd"
                                                />
                                                <path
                                                    fill="#00ad3c"
                                                    d="m256.293 173.808 4.212-107.064-84.604-32.663c-7.926 4.678-14.682 11.117-19.389 19.319L7.085 311.186C2.379 319.389.016 328.475 0 337.565l161.283.288z"
                                                    opacity={1}
                                                    data-original="#00ad3c"
                                                />
                                                <path
                                                    fill="#00831e"
                                                    d="m256.293 173.808 77.503-41.694 3.387-97.745c-7.909-4.706-16.996-7.068-26.379-7.085l-108.499-.194c-9.384-.017-18.479 2.606-26.405 6.991z"
                                                    opacity={1}
                                                    data-original="#00831e"
                                                />
                                                <path
                                                    fill="#0084ff"
                                                    d="m350.716 338.192-189.434-.338-80.89 139.438c7.909 4.706 16.996 7.068 26.379 7.085l297.933.532c9.384.017 18.479-2.606 26.405-6.991l.314-93.66z"
                                                    opacity={1}
                                                    data-original="#0084ff"
                                                />
                                                <path
                                                    fill="#ff4131"
                                                    d="M431.109 477.919c7.926-4.678 14.682-11.117 19.388-19.319l9.413-16.111 45.005-77.629c4.706-8.202 7.069-17.288 7.085-26.379l-93.221-49.051-67.768 48.764z"
                                                    opacity={1}
                                                    data-original="#ff4131"
                                                />
                                                <path
                                                    fill="#ffba00"
                                                    d="m430.756 182.917-74.253-129.16c-4.677-8.22-11.41-14.683-19.32-19.389l-80.891 139.439 94.423 164.385 160.99.288c.016-9.09-2.314-18.185-6.991-26.405z"
                                                    opacity={1}
                                                    data-original="#ffba00"
                                                />
                                            </g>
                                        </svg>

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width={20}
                                            height={20}
                                            x={0}
                                            y={0}
                                            viewBox="0 0 447.232 447.232"
                                            xmlSpace="preserve"
                                            className=""
                                        >
                                            <g>
                                                <path
                                                    d="M207.527 251.676 92.903 177.758a10.272 10.272 0 0 0-12.007.63L3.833 240.403c-5.458 4.392-5.015 12.839.873 16.636l114.624 73.918a10.272 10.272 0 0 0 12.007-.63l77.063-62.014c5.458-4.393 5.015-12.84-.873-16.637zM238.833 268.312l77.063 62.014a10.272 10.272 0 0 0 12.007.63l114.624-73.918c5.888-3.797 6.331-12.244.873-16.636l-77.063-62.014a10.272 10.272 0 0 0-12.007-.63l-114.624 73.918c-5.887 3.797-6.331 12.244-.873 16.636zM208.4 74.196l-77.063-62.014a10.272 10.272 0 0 0-12.007-.63L4.706 85.47c-5.888 3.797-6.331 12.244-.873 16.636l77.063 62.014a10.272 10.272 0 0 0 12.007.63l114.624-73.918c5.888-3.797 6.331-12.244.873-16.636zM442.527 85.47 327.903 11.552a10.272 10.272 0 0 0-12.007.63l-77.063 62.014c-5.458 4.392-5.015 12.839.873 16.636l114.625 73.918a10.272 10.272 0 0 0 12.007-.63l77.063-62.014c5.457-4.393 5.014-12.84-.874-16.636z"
                                                    style={{}}
                                                    fill="#1587ea"
                                                    data-original="#1587ea"
                                                    className=""
                                                />
                                                <path
                                                    d="m218 279.2-86.3 68.841a9.319 9.319 0 0 1-10.861.547L99.568 334.87c-6.201-3.999-14.368.453-14.368 7.831v7.416a9.32 9.32 0 0 0 4.488 7.969l128.481 77.884a9.317 9.317 0 0 0 9.661 0l128.481-77.884a9.319 9.319 0 0 0 4.488-7.969v-6.619c0-7.378-8.168-11.83-14.368-7.831l-20.024 12.913a9.318 9.318 0 0 1-10.876-.559l-85.893-68.809A9.32 9.32 0 0 0 218 279.2z"
                                                    style={{}}
                                                    fill="#1587ea"
                                                    data-original="#1587ea"
                                                    className=""
                                                />
                                            </g>
                                        </svg>

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width={20}
                                            height={20}
                                            x={0}
                                            y={0}
                                            viewBox="0 0 512 512"
                                            style={{ enableBackground: "new 0 0 512 512" }}
                                            xmlSpace="preserve"
                                            className="hovered-paths"
                                        >
                                            <g>
                                                <path
                                                    d="M191.309 122.22a102.052 102.052 0 0 0-19.709-1.92c-51.554 0-94.297 38.443-101.066 88.169C30.558 215.188 0 250.043 0 291.9c0 45.099 35.474 82.063 79.983 84.469A104.902 104.902 0 0 1 77 351.5c0-24.023 8.352-47.523 23.516-66.171 9.965-12.254 22.582-22.082 36.705-28.775 8.955-60.228 57.84-107.594 118.78-114.246l30-27.441-30-27.441c-24.612 4.462-47.2 16.544-64.692 34.794z"
                                                    style={{}}
                                                    fill="#007caa"
                                                    data-original="#007caa"
                                                    className=""
                                                />
                                                <path
                                                    d="M165.75 276.5c0 .589.005 1.179.015 1.77C132.188 285.708 107 315.718 107 351.5c0 41.355 33.645 75 75 75h74l60-126.979-60-126.979c-50.938 7.192-90.25 51.067-90.25 103.958z"
                                                    style={{}}
                                                    fill="#007caa"
                                                    data-original="#007caa"
                                                    className=""
                                                />
                                                <path
                                                    d="M450.959 277.802C444.343 234.653 406.971 201.5 362 201.5c-5.471 0-10.917.497-16.281 1.483-19.695-20.116-46.521-31.483-74.969-31.483-5.006 0-9.929.36-14.75 1.041V426.5h181c41.355 0 75-33.645 75-75 0-36.587-26.331-67.139-61.041-73.698zM355.844 171.659a119.715 119.715 0 0 1 37.375 3.988C380.139 123.906 333.198 85.5 277.45 85.5c-7.267 0-14.44.655-21.45 1.926v54.881c4.846-.529 9.766-.808 14.75-.808 31.441.001 61.14 10.615 85.094 30.16z"
                                                    style={{}}
                                                    fill="#015e82"
                                                    data-original="#015e82"
                                                    className="hovered-path"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    <i className='fas fa-info-circle me-1 text-info'></i>
                                    To quickly add multiple file links, paste a link and press Enter on your keyboard to add additional file links.
                                </p>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between flex-wrap'>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Chat
                            </Tooltip>
                        }
                    >
                        <button type='button' className="me-1 table-action-btn" onClick={() => handleMessageShow(taskDoneValue)}>
                            <i className="fas fa-comment-dots"></i>
                        </button>
                    </OverlayTrigger>
                    <button type='submit' className='btn btn-exp-green'>
                        Confirm
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default TaskDoneModal